var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntDesignCheckSquareOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.45923 12.8457C8.51672 12.9259 8.59251 12.9913 8.68031 13.0364C8.76811 13.0815 8.8654 13.1051 8.96411 13.1051C9.06282 13.1051 9.16011 13.0815 9.24791 13.0364C9.33572 12.9913 9.4115 12.9259 9.46899 12.8457L13.5823 7.14258C13.6565 7.03906 13.5823 6.89453 13.4553 6.89453H12.5393C12.3401 6.89453 12.1506 6.99023 12.0334 7.1543L8.96509 11.4121L7.57446 9.48242C7.45728 9.32031 7.26978 9.22266 7.06861 9.22266H6.15259C6.02564 9.22266 5.95142 9.36719 6.02564 9.4707L8.45923 12.8457Z",
    fill: "#B4C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignCheckSquareOutlined);
export default __webpack_public_path__ + "static/media/ant-design_check-square-outlined.caddc014df4b836ecb2879a8d7d03ac1.svg";
export { ForwardRef as ReactComponent };